import { useState, useRef, useEffect} from 'react';
import Landing from './Landing';
import { Routes, Route, useNavigate} from "react-router-dom";
import { API_CONFIG } from './api.js';




// Popular countries with their codes
const countries = [
  { code: '+1', name: 'United States', flag: '🇺🇸' },
  { code: '+1', name: 'Canada', flag: '🇨🇦' },
  { code: '+44', name: 'United Kingdom', flag: '🇬🇧' },
  { code: '+49', name: 'Germany', flag: '🇩🇪' },
  { code: '+33', name: 'France', flag: '🇫🇷' },
  { code: '+91', name: 'India', flag: '🇮🇳' },
  { code: '+86', name: 'China', flag: '🇨🇳' },
  { code: '+81', name: 'Japan', flag: '🇯🇵' },
  { code: '+61', name: 'Australia', flag: '🇦🇺' },
  { code: '+55', name: 'Brazil', flag: '🇧🇷' },
  { code: '+52', name: 'Mexico', flag: '🇲🇽' },
  { code: '+34', name: 'Spain', flag: '🇪🇸' },
  { code: '+39', name: 'Italy', flag: '🇮🇹' },
  { code: '+31', name: 'Netherlands', flag: '🇳🇱' },
  { code: '+46', name: 'Sweden', flag: '🇸🇪' },
  { code: '+47', name: 'Norway', flag: '🇳🇴' },
  { code: '+45', name: 'Denmark', flag: '🇩🇰' },
  { code: '+358', name: 'Finland', flag: '🇫🇮' },
  { code: '+41', name: 'Switzerland', flag: '🇨🇭' },
  { code: '+43', name: 'Austria', flag: '🇦🇹' },
  { code: '+32', name: 'Belgium', flag: '🇧🇪' },
  { code: '+351', name: 'Portugal', flag: '🇵🇹' },
  { code: '+30', name: 'Greece', flag: '🇬🇷' },
  { code: '+48', name: 'Poland', flag: '🇵🇱' },
  { code: '+420', name: 'Czech Republic', flag: '🇨🇿' },
  { code: '+36', name: 'Hungary', flag: '🇭🇺' },
  { code: '+7', name: 'Russia', flag: '🇷🇺' },
  { code: '+82', name: 'South Korea', flag: '🇰🇷' },
  { code: '+65', name: 'Singapore', flag: '🇸🇬' },
  { code: '+60', name: 'Malaysia', flag: '🇲🇾' },
  { code: '+66', name: 'Thailand', flag: '🇹🇭' },
  { code: '+84', name: 'Vietnam', flag: '🇻🇳' },
  { code: '+62', name: 'Indonesia', flag: '🇮🇩' },
  { code: '+63', name: 'Philippines', flag: '🇵🇭' },
  { code: '+64', name: 'New Zealand', flag: '🇳🇿' },
  { code: '+27', name: 'South Africa', flag: '🇿🇦' },
  { code: '+20', name: 'Egypt', flag: '🇪🇬' },
  { code: '+971', name: 'UAE', flag: '🇦🇪' },
  { code: '+966', name: 'Saudi Arabia', flag: '🇸🇦' },
  { code: '+972', name: 'Israel', flag: '🇮🇱' },
  { code: '+90', name: 'Turkey', flag: '🇹🇷' },
  { code: '+54', name: 'Argentina', flag: '🇦🇷' },
  { code: '+56', name: 'Chile', flag: '🇨🇱' },
  { code: '+57', name: 'Colombia', flag: '🇨🇴' },
  { code: '+51', name: 'Peru', flag: '🇵🇪' },
  { code: '+58', name: 'Venezuela', flag: '🇻🇪' },
  { code: '+234', name: 'Nigeria', flag: '🇳🇬' },
  { code: '+254', name: 'Kenya', flag: '🇰🇪' },
  { code: '+212', name: 'Morocco', flag: '🇲🇦' },
  { code: '+213', name: 'Algeria', flag: '🇩🇿' },
  { code: '+216', name: 'Tunisia', flag: '🇹🇳' },
  { code: '+380', name: 'Ukraine', flag: '🇺🇦' }
];

function AuthFlow() {
  const navigate = useNavigate();
  const [noiseUrl, setNoiseUrl] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(countries[2]);

  useEffect(() => {
    const dpr = window.devicePixelRatio || 1;
    const size = Math.round(256 * dpr);
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    const imageData = ctx.createImageData(size, size);
    for (let i = 0; i < imageData.data.length; i += 4) {
      const v = Math.random() * 255;
      imageData.data[i] = v;
      imageData.data[i + 1] = v;
      imageData.data[i + 2] = v;
      imageData.data[i + 3] = 255;
    }
    ctx.putImageData(imageData, 0, 0);
    setNoiseUrl(canvas.toDataURL());
  }, []); // Default to UK to match image
  const [phoneNumber, setPhoneNumber] = useState('');
  const [useremail, setUserEmail] = useState('')
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [showEnterPhone, setShowEnterPhone] = useState(false)
  const [showEmailOTP, setShowEmailOTP] = useState(false);
  const [caseId, setCaseId] = useState(false);
  const [screenerr, setScreenErr] = useState('');
  const [otpError, setOtpError] = useState('');
  const [emailOtpError, setEmailOtpError] = useState('');
  const [otp, setOTP] = useState(['', '', '', '', '', '']);
  const [emailOtp, setEmailOTP] = useState(['', '', '', '', '', '']);
  const [isLoading, setIsLoading] = useState(false);
  const [isAnalysing, setIsAnalysing] = useState(false);
  const [analysisResult, setAnalysisResult] = useState(null);
  const [Influences, setInfluences] = useState([])
  const [isFadingOut, setIsFadingOut] = useState(true);
  const [loadingStep, setLoadingStep] = useState(0);
  const otpRefs = useRef([]);
  const emailOtpRefs = useRef([]);

  const loadingSteps = [
"Processing Login",
"Analysing Message Data"
  ];

  // Auto-cycle through loading steps
  useEffect(() => {
    if (isLoading) {
      const interval = setInterval(() => {
        setLoadingStep(prevStep => {
          if (prevStep >= loadingSteps.length - 1) {
            return 0; // Loop back to start
          }
          return prevStep + 1;
        });
      }, 2000); // Change every 2 seconds

      return () => clearInterval(interval);
    }
  }, [isLoading, loadingSteps.length]);

  const handleSubmit = async () => {

    if (phoneNumber.trim()) {

      setScreenErr(''); // Clear previous errors
      setIsFadingOut(true); // Start fade out
      
      // Wait for fade out animation to complete
      setTimeout(async () => {


      setIsLoading(true); // Show loading screen immediately
      setLoadingStep(0); // Start with first message
      setIsFadingOut(false); // Fade in the loading scr


        try {
          const response = await fetch(`${API_CONFIG.baseURL}/initiateSMS`, {
            method: 'POST',
            credentials: 'include', 
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              phoneNumber: `${selectedCountry.code}${phoneNumber}`
            })
          });
          
          const data = await response.json();
          console.log('SMS API response:', data);

          if (response.ok) {
            console.log(`SMS initiated for: ${selectedCountry.code} ${phoneNumber}`);
            setShowOTP(true);
            setIsLoading(false)
            setIsFadingOut(false);
          } else {
            console.error('SMS failed:', response.status, data);
            setIsLoading(false)
            setScreenErr('Something went wrong');
            setIsFadingOut(false);
          }
        } catch (error) {
          console.log("This runs")
          setScreenErr('Network error. Please try again.');
          setIsFadingOut(false); // Fade back in with error
          console.error('Error initiating SMS:', error);
        }

      }, 300); // Match the CSS transition duration
    }
  };

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setIsDropdownOpen(false);
  };

  const formatPhoneNumber = (value) => {
    // Remove all non-digits
    const digits = value.replace(/\D/g, '');
    
    // Format based on country (simple US formatting as example)
    if (selectedCountry.code === '+1' && digits.length >= 6) {
      return digits.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }
    
    return digits;
  };

  const handlePhoneChange = (e) => {
    const formatted = formatPhoneNumber(e.target.value);
    setPhoneNumber(formatted);
  };

  const handleOTPChange = (index, value) => {
    const digit = value.replace(/\D/g, '').slice(-1); // Only keep the last digit
    const newOTP = [...otp];
    newOTP[index] = digit;
    setOTP(newOTP);

    // Auto-focus next input
    if (digit && index < 5) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  const handleOTPPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text/plain');
    const digits = pastedData.replace(/\D/g, '').slice(0, 6); // Extract only digits, max 6
    
    if (digits.length > 0) {
      const newOTP = [...otp];
      for (let i = 0; i < 6; i++) {
        newOTP[i] = digits[i] || '';
      }
      setOTP(newOTP);
      
      // Focus the last filled input or the first empty one
      const lastFilledIndex = Math.min(digits.length - 1, 5);
      const nextEmptyIndex = Math.min(digits.length, 5);
      otpRefs.current[nextEmptyIndex]?.focus();
    }
  };

  const handleLandingTransition = () =>{

}

  const handleEmailOTPChange = (index, value) => {
    const digit = value.replace(/\D/g, '').slice(-1); // Only keep the last digit
    const newOTP = [...emailOtp];
    newOTP[index] = digit;
    setEmailOTP(newOTP);

    // Auto-focus next input
    if (digit && index < 5) {
      emailOtpRefs.current[index + 1]?.focus();
    }
  };

  const handleEmailOTPPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text/plain');
    const digits = pastedData.replace(/\D/g, '').slice(0, 6); // Extract only digits, max 6
    
    if (digits.length > 0) {
      const newOTP = [...emailOtp];
      for (let i = 0; i < 6; i++) {
        newOTP[i] = digits[i] || '';
      }
      setEmailOTP(newOTP);
      
      // Focus the last filled input or the first empty one
      const lastFilledIndex = Math.min(digits.length - 1, 5);
      const nextEmptyIndex = Math.min(digits.length, 5);
      emailOtpRefs.current[nextEmptyIndex]?.focus();
    }
  };

  const handleOTPKeyDown = (index, e) => {
    // Handle backspace
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      otpRefs.current[index - 1]?.focus();
    }
  };

  const handleEmailOTPKeyDown = (index, e) => {
    // Handle backspace
    if (e.key === 'Backspace' && !emailOtp[index] && index > 0) {
      emailOtpRefs.current[index - 1]?.focus();
    }
  };

 
  useEffect(() => {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.href = '/hingelogo.png';
  document.head.appendChild(link);

  // Prevent scrolling on mobile without breaking interactions
  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';
  document.body.style.height = '100vh';
  document.body.style.height = '100dvh'; // Dynamic viewport height for better mobile support
  document.documentElement.style.height = '100vh';
  document.documentElement.style.height = '100dvh';
  
  // Prevent zoom on input focus (iOS Safari) - store original viewport
  const originalViewport = document.querySelector('meta[name=viewport]');
  const originalContent = originalViewport ? originalViewport.getAttribute('content') : null;
  
  if (originalViewport) {
    originalViewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover');
  } else {
    const newViewport = document.createElement('meta');
    newViewport.name = 'viewport';
    newViewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';
    document.head.appendChild(newViewport);
  }

  console.log("True")
  setTimeout(() => {
  setIsFadingOut(false);
    setShowEnterPhone(true);
  }, 100); 
  
  return () => {
    document.head.removeChild(link);
    // Restore scrolling when component unmounts
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';
    document.body.style.height = 'auto';
    document.documentElement.style.height = 'auto';
    
    // Restore original viewport if it existed
    if (originalViewport && originalContent) {
      originalViewport.setAttribute('content', originalContent);
    }
  };
}, []);

  const handleVerifyOTP = async () => {


    const otpString = otp.join('');
    if (otpString.length === 6) {
      setOtpError(''); 
      setIsFadingOut(true);
    
      setTimeout(async () => {
        setIsLoading(true)
        setIsFadingOut(false); 
        
        try {
          const response = await fetch(`${API_CONFIG.baseURL}/validateOTP`, {
            credentials: 'include', 
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              otp: otpString,
              phoneNumber: `${selectedCountry.code}${phoneNumber}`
            })
          });
          
          if (response.status === 412){
            const data = await response.json();
            setIsFadingOut(true);
            setTimeout(() => {
              setIsLoading(false);
              setShowOTP(false);
              setUserEmail(data.email)
              setCaseId(data.caseId)
              console.log(data.email)
              setShowEmailOTP(true);
              setLoadingStep(0)
              setIsFadingOut(false);
            }, 300);
          }
          else {
            setIsFadingOut(true);
            setTimeout(() => {
              setIsLoading(false);
              setOtpError('Invalid verification code. Please try again.');
              setIsFadingOut(false);
            }, 300);
            console.error('OTP verification failed');
          }
        } catch (error) {
          // Go back to OTP screen with error
          setIsFadingOut(true);
          setTimeout(() => {
            setIsLoading(false);
            setLoadingStep(0);
            setOtpError('Network error. Please try again.');
            setIsFadingOut(false);
          }, 300);
          console.error('Error verifying OTP:', error);
        }
      }, 300); // Match the CSS transition duration
    }
  };

  const handleVerifyEmailOTP = async () => {
    const emailOtpString = emailOtp.join('');
    if (emailOtpString.length === 6) {
      setEmailOtpError(''); 
      setIsFadingOut(true); // Start fade out
      
      // Wait for fade out animation to complete
      setTimeout(async () => {
        setIsLoading(true); // Show loading screen immediately
        setLoadingStep(0); // Start with first message
        setIsFadingOut(false); // Fade in the loading screen
        
        try {
          const response = await fetch(`${API_CONFIG.baseURL}/validateEmailOTP`, {
            credentials: 'include', 
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              code: emailOtpString,
              caseId: caseId
            })
          });
          
          if (response.ok) {
            const data = await response.json();
            setIsFadingOut(true);
            
            console.log('Email OTP verified successfully');

            setTimeout(() => {
              setIsLoading(false);
              setIsFadingOut(false);
              navigate('/results', {state: data});
            }, 300);
            
          } else {
            // Go back to email OTP screen with error
            setIsFadingOut(true);
            setTimeout(() => {
              setIsLoading(false);
              setLoadingStep(0);
              setEmailOtpError('Invalid email verification code. Please try again.');
              setIsFadingOut(false);
            }, 300);
            console.error('Email OTP verification failed');
          }
        } catch (error) {
          // Go back to email OTP screen with error
          setIsFadingOut(true);
          setTimeout(() => {
            setIsLoading(false);
            setLoadingStep(0);
            setEmailOtpError('Network error. Please try again.');
            setIsFadingOut(false);
          }, 300);
          console.error('Error verifying email OTP:', error);
        }
      }, 300); // Match the CSS transition duration
    }
  };

  const handleChangePhoneNumber = () => {
    setIsFadingOut(true); // Start fade out
    
    // Wait for fade out animation to complete
    setTimeout(() => {
      setShowOTP(false);
      setShowEmailOTP(false);
      setOTP(['', '', '', '', '', '']);
      setEmailOTP(['', '', '', '', '', '']);
      setOtpError('');
      setEmailOtpError('');
      setIsFadingOut(false); // Fade in the phone screen
    }, 300);
  };

 
  // Loading Screen
  if (isLoading) {
    return (
      <div className={`h-screen md:min-h-screen flex items-center justify-center overflow-hidden transition-all duration-300 md:p-16 lg:p-20 xl:p-24 ${
        isFadingOut ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
      }`}>
        <div className="fixed inset-0 -z-10" style={{ background: 'radial-gradient(ellipse at bottom right, #7c3aed 0%, #7c3aed22 70%, transparent 90%), radial-gradient(ellipse 70% 70% at top left, #ec4899 0%, #ec489922 65%, transparent 90%), #f5f5f5' }}>
          {noiseUrl && <div style={{ position: 'absolute', inset: 0, backgroundImage: `url(${noiseUrl})`, backgroundRepeat: 'repeat', backgroundSize: '256px 256px', mixBlendMode: 'soft-light', opacity: 0.35 }}/>}
        </div>
        <div className="text-center px-4 w-full">
          {/* Animated Logo */}
          <div className="mb-8 animate-pulse">
            <img 
              loading="eager"
              className="w-32 mx-auto opacity-80" 
              src="/hingelogo.png"
              alt="Hinge Logo" 
            />
          </div>
          
          {/* Loading Animation */}
          <div className="flex justify-center mb-8">
            <div className="flex space-x-2">
              <div className="w-3 h-3 bg-gray-900 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
              <div className="w-3 h-3 bg-gray-900 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
              <div className="w-3 h-3 bg-gray-900 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
            </div>
          </div>
          
          {/* Loading Text */}
          <p className="text-gray-600 text-lg font-medium animate-pulse">
            {loadingSteps[loadingStep]}
          </p>
          
          {/* Progress Bar */}
          <div className="mt-8 w-64 mx-auto">
            <div className="h-1 bg-gray-200 rounded-full overflow-hidden">
              <div className="h-full bg-gray-900 rounded-full animate-pulse" 
                   style={{
                     width: '60%',
                     animation: 'progress 2s ease-in-out infinite'
                   }}>
              </div>
            </div>
          </div>
        </div>
        
        {/* CSS for progress animation */}
        <style jsx>{`
          @keyframes progress {
            0% { width: 0%; }
            50% { width: 80%; }
            100% { width: 100%; }
          }
        `}</style>
      </div>
    );
  }

  // Email OTP Screen
  if (showEmailOTP) {
    return (
      <div className="h-screen md:min-h-screen flex items-center justify-center overflow-hidden md:p-16 lg:p-20 xl:p-24">
        <div className="fixed inset-0 -z-10" style={{ background: 'radial-gradient(ellipse at bottom right, #7c3aed 0%, #7c3aed22 70%, transparent 90%), radial-gradient(ellipse 70% 70% at top left, #ec4899 0%, #ec489922 65%, transparent 90%), #f5f5f5' }}>
          {noiseUrl && <div style={{ position: 'absolute', inset: 0, backgroundImage: `url(${noiseUrl})`, backgroundRepeat: 'repeat', backgroundSize: '256px 256px', mixBlendMode: 'soft-light', opacity: 0.35 }}/>}
        </div>
        <div className={`bg-white w-full h-full md:w-auto md:h-auto md:max-w-md md:rounded-3xl md:shadow-2xl md:border md:border-gray-100 flex items-center transition-all duration-300 p-8 ${
            isFadingOut ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
        }`}>
          <div className="w-full">
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Enter email verification code</h2>
              <p className="text-gray-600">We emailed a code to {useremail}</p>
            </div>

            <div className="flex justify-center space-x-3 mb-6">
              {emailOtp.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => emailOtpRefs.current[index] = el}
                  type="text"
                  inputMode="numeric"
                  value={digit}
                  onChange={(e) => handleEmailOTPChange(index, e.target.value)}
                  onKeyDown={(e) => handleEmailOTPKeyDown(index, e)}
                  onPaste={index === 0 ? handleEmailOTPPaste : undefined}
                  className="w-12 h-14 text-center text-2xl font-bold border-b-2 border-gray-900 focus:outline-none focus:border-gray-600 bg-transparent"
                  style={{fontSize: '24px'}} // Prevents zoom on iOS
                  maxLength="1"
                />
              ))}
            </div>

            {/* Email OTP Error Message */}
            {emailOtpError && (
              <div className='text-red-600 text-xs mb-4 text-center'>{emailOtpError}</div>
            )}

            <button
              onClick={handleVerifyEmailOTP}
              disabled={emailOtp.join('').length !== 6 || isFadingOut}
              className="w-full bg-gray-900 text-white py-3.5 px-4 rounded-full font-bold text-base hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2 transition-all duration-200 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-gray-900"
            >
              Verify Email Code
            </button>

            <button
              onClick={handleChangePhoneNumber}
              className="w-full mt-4 text-gray-600 hover:text-gray-900 font-medium"
            >
              Change phone number
            </button>
          </div>
        </div>
      </div>
    );
  }

  // OTP Screen
  if (showOTP) {
    return (
      <>
      <div className="h-screen md:min-h-screen flex items-center justify-center overflow-hidden md:p-16 lg:p-20 xl:p-24">
        <div className="fixed inset-0 -z-10" style={{ background: 'radial-gradient(ellipse at bottom right, #7c3aed 0%, #7c3aed22 70%, transparent 90%), radial-gradient(ellipse 70% 70% at top left, #ec4899 0%, #ec489922 65%, transparent 90%), #f5f5f5' }}>
          {noiseUrl && <div style={{ position: 'absolute', inset: 0, backgroundImage: `url(${noiseUrl})`, backgroundRepeat: 'repeat', backgroundSize: '256px 256px', mixBlendMode: 'soft-light', opacity: 0.35 }}/>}
        </div>
        <div className={`bg-white w-full h-full md:w-auto md:h-auto md:max-w-md md:rounded-3xl md:shadow-2xl md:border md:border-gray-100 flex items-center transition-all duration-300 p-8 ${
          isFadingOut ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
        }`}>
          <div className="w-full">
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Enter verification code</h2>
              <p className="text-gray-600">We sent a code to {selectedCountry.code} {phoneNumber}</p>
            </div>

            <div className="flex justify-center space-x-3 mb-6">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => otpRefs.current[index] = el}
                  type="text"
                  inputMode="numeric"
                  value={digit}
                  onChange={(e) => handleOTPChange(index, e.target.value)}
                  onKeyDown={(e) => handleOTPKeyDown(index, e)}
                  onPaste={index === 0 ? handleOTPPaste : undefined}
                  className="w-12 h-14 text-center text-2xl font-bold border-b-2 border-gray-900 focus:outline-none focus:border-gray-600 bg-transparent"
                  style={{fontSize: '24px'}} // Prevents zoom on iOS
                  maxLength="1"
                />
              ))}
              
            </div>

            {/* OTP Error Message */}
            {otpError && (
              <div className='text-red-600 text-xs mb-4 text-center'>{otpError}</div>
            )}

            <button
              onClick={handleVerifyOTP}
              disabled={otp.join('').length !== 6 || isFadingOut}
              className="w-full bg-gray-900 text-white py-3.5 px-4 rounded-full font-bold text-base hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2 transition-all duration-200 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-gray-900"
            >
              Verify
            </button>

            <button
              onClick={handleChangePhoneNumber}
              className="w-full mt-4 text-gray-600 hover:text-gray-900 font-medium"
            >
              Change phone number
            </button>
          </div>
        </div>
      </div>
      {/* Subtle background elements with floating animation */}
      </>
    );
  }

  return (
  
    <>
      <div className="h-screen md:min-h-screen flex items-center justify-center overflow-hidden md:p-16 lg:p-20 xl:p-24">
        <div className="fixed inset-0 -z-10" style={{ background: 'radial-gradient(ellipse at bottom right, #7c3aed 0%, #7c3aed22 70%, transparent 90%), radial-gradient(ellipse 70% 70% at top left, #ec4899 0%, #ec489922 65%, transparent 90%), #f5f5f5' }}>
          {noiseUrl && <div style={{ position: 'absolute', inset: 0, backgroundImage: `url(${noiseUrl})`, backgroundRepeat: 'repeat', backgroundSize: '256px 256px', mixBlendMode: 'soft-light', opacity: 0.35 }}/>}
        </div>
        <div className={`bg-white w-full h-full md:w-auto md:h-auto md:max-w-md md:rounded-3xl md:shadow-2xl md:border md:border-gray-100 flex items-center transition-all duration-300 p-8 ${
          isFadingOut ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
        }`}>
          <div className="w-full">
            <div className="flex flex-col items-center space-y-4">
              <img className="w-44 md:w-40 lg:w-48" src="/hingelogo.png" alt="Hinge Logo" />

              <p className="text-gray-800 text-center text-sm md:text-base font-medium">
                Login via Hinge
              </p>
              <br></br>
            </div>

            <div className="space-y-6">
              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-gray-900 mb-2">
                  Phone Number
                </label>
                
                <div className="flex space-x-4">
                  {/* Country Selector */}
                  <div className="relative">
                    <button
                      type="button"
                      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                      className="flex items-center px-3 py-3 bg-white focus:outline-none transition-colors border-b border-black hover:border-gray-800 focus:border-gray-800"
                    >
                      <span className="mr-2">{selectedCountry.flag}</span>
                      <span className="text-sm font-medium text-gray-900">{selectedCountry.code}</span>
                      <svg className="ml-1 h-4 w-4 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>

                    {/* Dropdown */}
                    {isDropdownOpen && (
                      <div className="absolute top-full left-0 mt-1 w-72 bg-white border border-gray-200 rounded-lg shadow-xl z-10 max-h-60 overflow-y-auto">
                        {countries.map((country, index) => (
                          <button
                            key={index}
                            type="button"
                            onClick={() => handleCountrySelect(country)}
                            className="flex items-center w-full px-4 py-3 text-left hover:bg-gray-50 focus:bg-gray-50 focus:outline-none first:rounded-t-lg last:rounded-b-lg transition-colors"
                          >
                            <span className="mr-3">{country.flag}</span>
                            <span className="flex-1 text-sm font-medium">{country.name}</span>
                            <span className="text-sm font-medium text-gray-600">{country.code}</span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Phone Input */}
                  <input
                    type="tel"
                    id="phone"
                    value={phoneNumber}
                    onChange={handlePhoneChange}
                    placeholder=""
                    className="flex-1 py-3 bg-white border-b border-black focus:outline-none focus:border-gray-800 font-medium text-gray-900 placeholder-gray-400"
                    style={{fontSize: '16px'}} // Prevents zoom on iOS
                    required
                  />
                </div>
              </div>
              {screenerr && (
                <div className='text-red-600 text-xs'>{screenerr}</div>
              )}
              <button
                type="button"
                onClick={handleSubmit}
                disabled={!phoneNumber.trim() || isFadingOut}
                className="w-full bg-gray-900 text-white py-3.5 px-4 rounded-full font-bold text-base hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2 transition-all duration-200 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-gray-900"
              >
                Continue
              </button>
            </div>

            <div className="mt-6 text-center">
              <p className="text-xs text-gray-600">
               * We are in no way affiilated with Hinge
              </p>
              <p className="text-xs text-gray-600 mt-1">
               * Accounts created with Google or Apple aren't supported yet
              </p>
            </div>
          </div>
        </div>
      </div>
    </>

  );
}


export default AuthFlow;